export interface IOrderMainProps {
  orderId: number;
}

export enum EOrderMainTab {
  cargos = 'cargos',
  documents = 'documents',
  invoices = 'invoices',
  expenses = 'expenses',
  additionalCosts = 'additionalCosts',
}
